import toMap from '~/misc/toMap';

export default toMap([
  'SAVE_ACCOUNT_INFO_WRAP',
  'PROFILE_PAGE_SAVE_ACCOUNT_INFO',
  'PROFILE_PAGE_ASYNG_ERROR_HIDE',
]);



// WEBPACK FOOTER //
// ./src/modules/accountProfilePage/types.js